import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/contexts/LanguageContext";

const LanguageSwitcher = ({ compact = false }) => {
  const { lang, setLang } = useLang();

  return (
    <div
      data-testid="language-switcher"
      className={`inline-flex items-center gap-0 border border-white/15 bg-black/40 backdrop-blur-md ${compact ? "p-0.5" : "p-1"} relative`}
      role="tablist"
      aria-label="Language selector"
    >
      {["en", "tr"].map((code) => {
        const active = lang === code;
        return (
          <button
            key={code}
            data-testid={`lang-btn-${code}`}
            onClick={() => setLang(code)}
            role="tab"
            aria-selected={active}
            className={`relative px-3 md:px-4 py-1.5 text-[11px] font-semibold tracking-[0.25em] transition-colors ${
              active ? "text-white" : "text-white/50 hover:text-white/80"
            }`}
          >
            {active && (
              <motion.span
                layoutId="lang-pill"
                className="absolute inset-0 bg-[var(--hk-red)]"
                transition={{ type: "spring", stiffness: 300, damping: 30 }}
              />
            )}
            <span className="relative z-10">{code.toUpperCase()}</span>
          </button>
        );
      })}
    </div>
  );
};

export default LanguageSwitcher;
